import React from 'react';
/* eslint-disable */
export function Timer(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 0.1875C3.36328 0.1875 0.4375 3.14062 0.4375 6.75C0.4375 10.3867 3.36328 13.3125 7 13.3125C10.6094 13.3125 13.5625 10.3867 13.5625 6.75C13.5625 3.14062 10.6094 0.1875 7 0.1875ZM7 12C4.10156 12 1.75 9.64844 1.75 6.75C1.75 3.87891 4.10156 1.5 7 1.5C9.87109 1.5 12.25 3.87891 12.25 6.75C12.25 9.64844 9.87109 12 7 12ZM7.65625 6.85938V3.90625C7.65625 3.55078 7.35547 3.25 7 3.25C6.61719 3.25 6.34375 3.55078 6.34375 3.90625V7.1875C6.34375 7.40625 6.42578 7.59766 6.58984 7.73438L8.33984 9.04688C8.44922 9.12891 8.58594 9.15625 8.72266 9.15625C8.94141 9.15625 9.13281 9.07422 9.26953 8.91016C9.48828 8.60938 9.43359 8.19922 9.13281 7.98047L7.65625 6.85938Z"
        fill="currentColor"
      />
    </svg>
  );
}
